class QuickAddProduct {
    constructor() {
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }
    
    addSelectedVariant(variantId, productId) {

        const formData = {
            items: [{
                id: variantId,
                quantity: 1,
                properties: { 'quick_add': true }
            }],
            sections: "cart-drawer,cart-icon-bubble"
        };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then(data => {

            // Verifica se temos itens no carrinho
            if (data.items || (data.sections && Object.keys(data.sections).length > 0)) {
                if (this.cart) {
                    this.handleCartUpdated(data.items || [], data.sections || {});
                    // Exibe o drawer do carrinho ao invés de redirecionar
                    this.cart.open();
                } else {
                    console.warn("Elemento do carrinho não encontrado, mas não vamos redirecionar");
                    // Não redirecionamos para o checkout, apenas atualizamos a página se necessário
                    // window.location.reload();
                }
            } else if (data.status && data.status === 422) {
                // Erro na adição do produto
                console.error("Erro ao adicionar produto:", data.description);
            }
        })
        .catch(error => {
            console.error('Erro na requisição:', error);
        });
    }
    
    handleCartUpdated(items, sections) {
        
        if (this.cart) {
            // Remover a classe is-empty se existir
            if (this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
            }
            
            try {
                // Define o elemento ativo para o drawer
                this.cart.setActiveElement(document.activeElement);
                
                // Renderiza o conteúdo no carrinho
                if (items.length > 0) {
                    items.forEach(item => {
                        this.cart.renderContents({
                            ...item,
                            sections: sections
                        });
                    });
                }
                
                // Garante que o formulário do carrinho esteja visível
                const cartForm = document.getElementById("CartDrawer-Form");
                if (cartForm) {
                    cartForm.style.display = "block";
                }
                
                // Força a abertura do carrinho
                if (typeof this.cart.open === 'function') {
                    this.cart.open();
                }
            } catch (e) {
                console.error("Erro ao atualizar o carrinho:", e);
            }
        } else {
            console.warn("Elemento do carrinho não encontrado para atualização");
        }
    }
}

// Inicializa a classe apenas quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
    window.quickAddProduct = new QuickAddProduct();
});